/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, Fragment, useMemo } from "react";
import _ from "lodash";
import { useHistory } from "react-router";

import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import UpdateIcon from "@material-ui/icons/Update";
import {
  Framework,
  PD_COACHEE_URL,
  PD_COACH_URL,
  COACH_URL,
  COACHEE_URL,
  SessionType,
  CONV_COACHEE_URL,
  CONV_COACH_URL,
} from "../../../config/Config";
import { isWithinDateRange, utcToLocal } from "../../../utils/datetime";
import { Pagination } from "../../../components/Pagination";
import Button from "../../../components/Button";
import Select from "../../../components/Select";
import { PerPage } from "../../../components/PerPage";
import styles from "./SessionsOverview.module.scss";
import { IsSupportAdmin } from "../../../config/Roles";
import { useTranslation } from "react-i18next";
import DateRangePicker from "../../../components/DateRangePicker";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "../../../components/Autocomplete";
import { FilterListOutlined } from "@material-ui/icons";
import { apiRequest } from "../../../utils/api";
import { useNotification } from "../../../context/notification";
import Search from "../../../components/Search";
import { getLocalValue } from "../../../utils/auth";

const useSortableData = (items, config = null) => {
  //state variables
  const [sortConfig, setSortConfig] = useState(config);

  const sortedItems = useMemo(() => {
    let sortableItems = [...items];
    if (
      sortConfig !== null &&
      sortConfig.key !== "session_ongoing_upcoming_date"
    ) {
      sortableItems.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    }
    if (
      sortConfig !== null &&
      sortConfig.key === "session_ongoing_upcoming_date"
    ) {
      sortableItems.sort((a, b) => {
        if (
          new Date(a[sortConfig.key]).getTime() <
          new Date(b[sortConfig.key]).getTime()
        ) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (
          new Date(a[sortConfig.key]).getTime() >
          new Date(b[sortConfig.key]).getTime()
        ) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableItems;
  }, [items, sortConfig]);

  const requestSort = key => {
    let direction = "descending";
    if (
      sortConfig &&
      sortConfig.key === key &&
      sortConfig.direction === "descending"
    ) {
      direction = "ascending";
    }
    setSortConfig({ key, direction });
  };

  return { items: sortedItems, requestSort, sortConfig };
};

const SortableTable = ({
  tableData,
  isCampaign,
  accessToCreateSession = true,
  perPage,
  setPerPage,
  subjectParam,
  source = null,
  selectedCampaign = null,
  selectedCountry = null,
  onUpdatingFilter,
  ...props
}) => {
  const history = useHistory();
  const { t } = useTranslation();
  const [uid] = useState(getLocalValue("uid"));

  const { addNotification } = useNotification();
  const overviewFilterBy = [
    { value: "0", label: "Pending Confirmation" },
    { value: "1", label: "Scheduled" },
    { value: "2", label: "Pending Checkpoints" },
    { value: "3", label: "Progressing" },
    { value: "4", label: "Ready for Review" },
    { value: "5", label: "Pending Rating" },
    { value: "All status", label: t("sessionList.allStatus") },
  ];
  const [filteredData, setFilteredData] = useState(tableData);
  const [dateFilteredData, setDateFilteredData] = useState(tableData);
  const { items, requestSort, sortConfig } = useSortableData(filteredData);
  const [totalData, setTotalData] = useState(filteredData.length);

  const [offset, setOffset] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [StatusFilterBy, setStatusFilterBy] = useState("All status");
  const [CoachesFilterBy, setCoachesFilterBy] = useState("All coaches");

  const tableHeader = props.tableHeader;
  const sessionUrl = props.isPersonal ? COACHEE_URL : COACH_URL;

  //Filter
  const [sessionTypes, setSessionTypes] = useState([
    { value: "All", label: "All types" },
  ]);
  const [sessionCoachees, setSessionCoachees] = useState([
    { value: "All", label: "All coachees" },
  ]);
  const [sessionCoach, setSessionCoach] = useState([
    { value: "All", label: "All coaches" },
  ]);
  const [sessionSubjects, setSessionSubject] = useState([
    { value: "", label: "All subjects", subject: "" },
  ]);
  const [showFilter, setShowFilter] = useState(false);
  const [selectedDateRange, setSelectedDateRange] = useState({});
  const [selectedSubject, setSelectedSubject] = useState({
    value: "",
    label: "All subjects",
    subject: "",
  });
  const [selectedType, setSelectedType] = useState("All");
  const [selectedSessionCoachee, setSelectedSessionCoachee] = useState("All");
  const [selectedSessionCoach, setSelectedSessionCoach] = useState("All");
  const [startEndDate, setStartEndDate] = useState({});

  const handlePaginationChange = offset => {
    setOffset(offset.selected * perPage);
    setPageNumber(offset.selected + 1);
  };

  const handleDateFilter = ({ startDate, endDate }) => {
    setStartEndDate({ startDate, endDate });
    let filteredItems = tableData.filter(item => {
      return (
        isWithinDateRange(
          item.session_ongoing_upcoming_date,
          startDate,
          endDate
        ) ||
        isWithinDateRange(item.progress.session_datetime, startDate, endDate)
      );
    });

    filteredItems = filteredItems.map(element => {
      return { ...element, subject: element.subject?.trim() };
    });

    setOffset(0);
    setFilteredData(filteredItems);
    setDateFilteredData(filteredItems);
    setTotalData(filteredItems.length);
    onUpdatingFilter(filteredItems.length);
  };

  // helper method to handle form changes
  const handleFilter = filterObj => {
    const filteredItems = _.filter(dateFilteredData, filterObj);
    setOffset(0);
    setFilteredData(filteredItems);
    setTotalData(filteredItems.length);
    onUpdatingFilter(filteredItems.length);
  };

  const clearFilter = () => {
    setStatusFilterBy("All status");
    setSelectedType("All");
    setSelectedDateRange({});
    setSelectedSubject({
      value: "",
      label: "All subjects",
      subject: "",
    });
    setOffset(0);
    setFilteredData(tableData);
    setDateFilteredData(tableData);
    setTotalData(tableData.length);
    onUpdatingFilter(tableData.length);
    setSelectedSessionCoachee("All");
    setSelectedSessionCoach("All");
  };

  const currentPageData = items.slice(offset, offset + perPage);

  useEffect(() => {
    setOffset(0);
    getOngoingSessionSubject();
    setFilteredData(tableData);
    getSessionType(tableData);
    getSessionCoachees(tableData);
    // getSessionSubjects(tableData);

    //check for filterdata in storage
    const sessionFilterDataStr = sessionStorage.getItem("sessionFilterData");
    showFilter && handleDateFilter(startEndDate);
    if (sessionFilterDataStr) {
      const sessionFilterData = JSON.parse(sessionFilterDataStr);
      if (
        sessionFilterData.showFilter &&
        sessionFilterData.showFilter === true
      ) {
        setShowFilter(true);
        setSelectedDateRange(sessionFilterData.selectedDateRange);
        setSelectedType(sessionFilterData.selectedType);
        setSelectedSessionCoach(sessionFilterData.selectedSessionCoach);
        setSelectedSessionCoachee(sessionFilterData.selectedSessionCoachee);
        setStatusFilterBy(sessionFilterData.StatusFilterBy);
        setCoachesFilterBy(sessionFilterData.CoachesFilterBy);
        setSelectedSubject(sessionFilterData.selectedSubject);
        sessionStorage.removeItem("sessionFilterData");
      }
    }
  }, [tableData, selectedCampaign, selectedCountry]);

  useEffect(() => {
    let filterObj = {};

    if (StatusFilterBy !== "All status") {
      filterObj.status = parseInt(StatusFilterBy);
    }
    if (selectedType !== "All") {
      filterObj.type = selectedType;
    }
    if (selectedSessionCoachee !== "All") {
      filterObj.coachee_id = selectedSessionCoachee;
    }
    if (selectedSessionCoach !== "All") {
      filterObj.coach_id = selectedSessionCoach;
    }
    if (selectedSubject?.subject !== "") {
      filterObj.subject = selectedSubject?.subject;
      filterObj.sub_subject = selectedSubject?.label;
    }

    handleFilter(filterObj);
  }, [
    StatusFilterBy,
    CoachesFilterBy,
    selectedType,
    selectedSubject,
    dateFilteredData,
    selectedSessionCoachee,
    selectedSessionCoach,
    showFilter,
  ]);

  useEffect(() => {
    if (filteredData) {
      setTotalData(filteredData.length);
      onUpdatingFilter(filteredData.length);
      requestSort("session_ongoing_upcoming_date");
    }
  }, [filteredData]);

  const getSessionType = data => {
    const tempTypes = [];
    data.forEach(element => {
      if (!element?.type) return;

      let currentType = {
        value: element.type,
        label: element.type,
      };
      tempTypes.push(currentType);
    });

    setSessionTypes((prev) => {
      return _.uniqBy([...prev, ...tempTypes], "value");
    });
  };

  const getSessionCoachees = data => {
    const tempCoachees = [];
    const tempCoach = [];
    data.forEach(element => {
      let currentCoachee = {
        value: element.coachee_id ? element.coachee_id : "",
        label: element.coachee_fullname ? element.coachee_fullname : "",
      };
      let currentCoach = {
        value: element.coach_id ? element.coach_id : "",
        label: element.coach_fullname ? element.coach_fullname : "",
      };
      tempCoach.push(currentCoach);
      tempCoachees.push(currentCoachee);
    });

    setSessionCoachees((prev) => {
      return _.uniqBy([...prev, ...tempCoachees], "value");
    });

    setSessionCoach((prev) => {
      return _.uniqBy([...prev, ...tempCoach], "value");
    });
  };

  const getOngoingSessionSubject = async () => {
    const url = source
      ? `/api/getSupportAdminOngoingSessionSubject?country_id=${selectedCountry}&campaign_id=${selectedCampaign}`
      : `/api/getOngoingSessionSubject?${subjectParam}`;
    const response = await apiRequest.get(url);
    if (response.status === 200) {
      const data = response.data.data;
      const tempTypes = [];
      data.forEach(element => {
        let currentType = {
          value: element.sub_subject,
          label: element.sub_subject,
          subject: element.subject.trim(),
        };
        tempTypes.push(currentType);
      });

      setSessionSubject((prev) => {
        const merged = [...prev, ...tempTypes]; // combine old + new
        const unique = _.uniqBy(merged, "value"); // remove duplicates
        return _.sortBy(unique, "subject"); // keep sorted
      });
    } else {
      addNotification(
        t("error.couldNotGetSession") + ` (Status code: ${response.status})`,
        "error"
      );
    }
  };

  function Row(props) {
    const { row } = props;
    const [open, setOpen] = useState(false);
    return (
      <React.Fragment>
        <TableRow
          className={`${styles.tableRow} ${open ? styles.openRow : ""}`}
          onClick={() => {
            const isPDSession = row.framework === Framework.PD;
            const isConversationalSession =
              row.session_type_id === SessionType.Conversational;
            const isCoachee = parseInt(uid) === row.coachee_id;
            let URL = "";
            if (isCoachee) {
              if (isPDSession) {
                URL = PD_COACHEE_URL;
              } else if (isConversationalSession) {
                URL = CONV_COACHEE_URL;
              } else {
                URL = COACHEE_URL;
              }
            } else {
              if (isPDSession) {
                URL = PD_COACH_URL;
              } else if (isConversationalSession) {
                URL = CONV_COACH_URL;
              } else {
                URL = COACH_URL;
              }
            }

            const fData = {
              showFilter,
              selectedDateRange,
              selectedType,
              selectedSessionCoach,
              selectedSessionCoachee,
              selectedSubject,
              StatusFilterBy,
              CoachesFilterBy,
            };
            sessionStorage.setItem("sessionFilterData", JSON.stringify(fData));
            history.push(`${URL[row.status]}${row.session_id}`);
          }}
        >
          <TableCell className={`${open ? styles.openRow : ""}`}>
            {row.session_ongoing_upcoming_date
              ? utcToLocal(row.session_ongoing_upcoming_date).format(
                  "DD MMM YYYY"
                )
              : utcToLocal(row.progress.session_datetime).format("DD MMM YYYY")}
            {row.progress.review_rescheduled === 1 && (
              <UpdateIcon color="primary" style={{ fontSize: "16px" }} />
            )}
          </TableCell>
          <TableCell className={`${open ? styles.openRow : ""}`}>
            {utcToLocal(row.progress.session_datetime).format("DD MMM YYYY")}
          </TableCell>
          <TableCell className={`${open ? styles.openRow : ""}`}>
            {row.session_id}
          </TableCell>
          <TableCell className={`${open ? styles.openRow : ""}`}>
            {row.session_ongoing_upcoming_date
              ? utcToLocal(row.session_ongoing_upcoming_date).format("h:mm A")
              : utcToLocal(row.progress.session_datetime).format("h:mm A")}
          </TableCell>

          <TableCell className={`${open ? styles.openRow : ""}`}>
            {row.framework !== Framework.PD
              ? row.type
              : "Behaviour and conduct"}
          </TableCell>
          <TableCell className={`${open ? styles.openRow : ""}`}>
            {row.subject}
          </TableCell>
          {(isCampaign || IsSupportAdmin()) && (
            <>
              <TableCell className={`${open ? styles.openRow : ""}`}>
                {row.coach_fullname}
              </TableCell>
              <TableCell className={`${open ? styles.openRow : ""}`}>
                {row.coach_employee_id}
              </TableCell>
            </>
          )}
          <TableCell className={`${open ? styles.openRow : ""}`}>
            {row.coachee_fullname}
          </TableCell>
          <TableCell className={`${open ? styles.openRow : ""}`}>
            {row.coachee_employee_id}
          </TableCell>
          <TableCell className={`${open ? styles.openRow : ""}`}>
            <span className={styles.status}>{row.session_status}</span>
          </TableCell>
          <TableCell className={`${open ? styles.openRow : ""}`}>
            <IconButton
              aria-label="expand row"
              size="small"
              style={{ outline: "none" }}
              onClick={e => {
                e.stopPropagation();
                setOpen(!open);
              }}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
        </TableRow>
        <TableRow className={styles.tableDetailsRow}>
          <TableCell
            style={{ padding: "0", borderBottomWidth: open ? "1px" : 0 }}
            colSpan={7}
          >
            <Collapse
              in={open}
              timeout="auto"
              style={{
                padding: "16px",
                overflow: "hidden",
                marginTop: "-22px",
              }}
              unmountOnExit
            >
              <Table size="small" aria-label="purchases">
                <TableBody>
                  <RowDetails
                    isPDSession={row.framework === Framework.PD}
                    rowDetails={row.progress}
                  />
                </TableBody>
              </Table>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  function RowDetails(props) {
    const { rowDetails } = props;

    let sessionDetailObl = {};

    if (rowDetails["session_datetime"]) {
      sessionDetailObl.sessionLabel = "Coaching";
      sessionDetailObl.sessionDate = utcToLocal(
        rowDetails["session_datetime"]
      ).format("DD MMM YYYY");
      sessionDetailObl.sessionTime = utcToLocal(
        rowDetails["session_datetime"]
      ).format("h:mm A");
      sessionDetailObl.sessionCompleted = rowDetails[
        "session_datetime_completed"
      ]
        ? true
        : false;
    }

    if (rowDetails["review_datetime"]) {
      sessionDetailObl.reviewLabel = "Review";
      sessionDetailObl.reviewDate = utcToLocal(
        rowDetails["review_datetime"]
      ).format("DD MMM YYYY");
      sessionDetailObl.reviewTime = utcToLocal(
        rowDetails["review_datetime"]
      ).format("h:mm A");
      sessionDetailObl.reviewCompleted = rowDetails["review_datetime_completed"]
        ? true
        : false;
    }

    const to_be_ensembled = _.pickBy(rowDetails, (value, key) =>
      _.includes(key, "checkpoint_date")
    );

    let sessionCheckPoints = [];
    if (!_.isEmpty(to_be_ensembled)) {
      for (let i = 0; i < Object.keys(to_be_ensembled).length; i++) {
        let checkpoint = {};
        checkpoint.label = "Checkpoint " + (i + 1);
        if (to_be_ensembled["checkpoint_date_" + (i + 1)]) {
          checkpoint.date = to_be_ensembled["checkpoint_date_" + (i + 1)];
        }
        if (to_be_ensembled["checkpoint_date_" + (i + 1) + "_completed"]) {
          checkpoint.completed =
            to_be_ensembled["checkpoint_date_" + (i + 1) + "_completed"];
        }
        sessionCheckPoints.push(checkpoint);
      }
      const filteredCheckPoint = _.filter(sessionCheckPoints, function (obj) {
        if (obj.date) return obj;
      });
      sessionDetailObl.checkPoints = [...filteredCheckPoint];
    }

    return (
      <Fragment>
        <TableRow className={styles.tableDetailsRow}>
          <TableCell
            className={`${styles.tableDetailsColumn} ${styles.lineIndication}`}
            style={{ width: "15%" }}
          >
            {!sessionDetailObl.sessionCompleted && (
              <FiberManualRecordIcon className={styles.nonCompleted} />
            )}
            {sessionDetailObl.sessionCompleted && (
              <CheckCircleIcon className={styles.completed} />
            )}
            {sessionDetailObl.sessionDate}
          </TableCell>
          <TableCell
            className={styles.tableDetailsColumn}
            style={{ width: "10%" }}
          >
            {sessionDetailObl.sessionTime}
          </TableCell>
          <TableCell
            className={styles.tableDetailsColumn}
            style={{ width: "10%" }}
          >
            {sessionDetailObl.sessionLabel}
          </TableCell>
          <TableCell
            className={styles.tableDetailsColumn}
            style={{ width: "65%" }}
          ></TableCell>
        </TableRow>
        {sessionDetailObl.checkPoints &&
          sessionDetailObl.checkPoints.map((checkPoint, index) => (
            <TableRow key={index} className={styles.tableDetailsRow}>
              <TableCell
                className={`${styles.tableDetailsColumn} ${styles.lineIndication}`}
                style={{ width: "15%" }}
              >
                {!checkPoint.completed && (
                  <FiberManualRecordIcon className={styles.nonCompleted} />
                )}
                {checkPoint.completed && (
                  <CheckCircleIcon className={styles.completed} />
                )}
                {utcToLocal(checkPoint.date).format("DD MMM YYYY")}
              </TableCell>
              <TableCell
                className={styles.tableDetailsColumn}
                style={{ width: "10%" }}
              >
                -
              </TableCell>
              <TableCell
                className={styles.tableDetailsColumn}
                style={{ width: "10%" }}
              >
                {checkPoint.label}
              </TableCell>
              <TableCell
                className={styles.tableDetailsColumn}
                style={{ width: "65%" }}
              ></TableCell>
            </TableRow>
          ))}

        {!props.isPDSession && (
          <TableRow className={styles.tableDetailsRow}>
            <TableCell
              className={`${styles.tableDetailsColumn} ${styles.lineIndication}`}
              style={{ width: "15%" }}
            >
              {!sessionDetailObl.reviewCompleted && (
                <FiberManualRecordIcon className={styles.nonCompleted} />
              )}
              {sessionDetailObl.reviewCompleted && (
                <CheckCircleIcon className={styles.completed} />
              )}
              {sessionDetailObl.reviewDate}
            </TableCell>
            <TableCell
              className={styles.tableDetailsColumn}
              style={{ width: "10%" }}
            >
              {sessionDetailObl.reviewTime}
            </TableCell>
            <TableCell
              className={styles.tableDetailsColumn}
              style={{ width: "10%" }}
            >
              {sessionDetailObl.reviewLabel}
            </TableCell>
            <TableCell
              className={styles.tableDetailsColumn}
              style={{ width: "65%" }}
            ></TableCell>
          </TableRow>
        )}
      </Fragment>
    );
  }

  const handleSearch = val => {
    const filterData = tableData.filter(item => {
      //item.session_id.contain(parseInt(val));
      return (item.session_id + "").indexOf(val) > -1;
    });
    setFilteredData(filterData);
  };

  return (
    <Fragment>
      {source && (
        <div>
          <Search
            handleSearch={handleSearch}
            placeholder="Search by Session ID"
          />
        </div>
      )}
      <div className={styles.headerWrapper}>
        {accessToCreateSession && (
          <Button
            color="secondary"
            variant="contained"
            className={styles.createSessionButton}
            onClick={() => {
              history.push("/sessions/form/new");
            }}
            startIcon={<AddCircleIcon />}
          >
            {t("sessionList.createSession")}
          </Button>
        )}
        <div className={styles.filterWrapper}>
          <div
            onClick={() => {
              handleFilter({});
              setShowFilter(!showFilter);
            }}
            className={styles.filterButton}
          >
            {t("logs.filter")}
            <FilterListOutlined />
          </div>
          {showFilter && (
            <div className={styles.filterRow}>
              <div className={styles.dateRange}>
                <DateRangePicker
                  selectedDateRange={selectedDateRange}
                  handleDateChange={handleDateFilter}
                  disableFuture
                />
              </div>

              <Select
                list={sessionTypes}
                value={selectedType}
                className={styles.filterDropDown}
                onChange={e => {
                  setSelectedType(e.target.value);
                }}
              />

              <Autocomplete
                value={selectedSubject}
                defaultValue={selectedSubject}
                onChange={(event, newValue) => {
                  setSelectedSubject(newValue);
                }}
                options={sessionSubjects}
                groupBy={option => option.subject}
                getOptionLabel={option => option.label}
                style={{ width: 150, marginRight: "10px" }}
                renderInput={params => (
                  <TextField
                    {...params}
                    placeholder={t("logs.subjects")}
                    variant="outlined"
                  />
                )}
              />

              <Select
                list={sessionCoachees}
                value={selectedSessionCoachee}
                searchable
                className={styles.searchableField}
                onChange={e => {
                  setSelectedSessionCoachee(e.target.value);
                }}
              />
              <Select
                list={sessionCoach}
                searchable
                value={selectedSessionCoach}
                className={styles.searchableField}
                onChange={e => {
                  setSelectedSessionCoach(e.target.value);
                }}
              />
              <Select
                list={overviewFilterBy}
                value={StatusFilterBy}
                className={styles.searchableField}
                onChange={e => {
                  setStatusFilterBy(e.target.value);
                }}
              />

              <div>
                <Button
                  className={styles.clearButton}
                  onClick={() => {
                    setShowFilter(false);
                    clearFilter();
                  }}
                >
                  {t("logs.clearAll")}
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>

      <TableContainer component={Paper} elevation={0}>
        <Table aria-label="Team" className={styles.table}>
          <TableHead className={styles.tableHead}>
            <TableRow>
              {tableHeader.map((tableHead, index) => (
                <TableCell
                  key={index}
                  style={{ width: tableHead.width, padding: "14px 10px" }}
                  className={styles.tableHeadCell}
                  onClick={() =>
                    tableHead.name !== "" ? requestSort(tableHead.name) : ""
                  }
                >
                  {tableHead.label}

                  {sortConfig &&
                    sortConfig.key === tableHead.name &&
                    sortConfig.direction === "ascending" && (
                      <span>
                        <KeyboardArrowUpIcon fontSize="small" />
                      </span>
                    )}
                  {sortConfig &&
                    sortConfig.key === tableHead.name &&
                    sortConfig.direction === "descending" && (
                      <span>
                        <KeyboardArrowDownIcon fontSize="small" />
                      </span>
                    )}
                </TableCell>
              ))}
              <TableCell style={{ width: "3%" }}></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {currentPageData &&
              currentPageData.map((row, index) => (
                <Row key={index} row={row} />
              ))}
            {_.isEmpty(filteredData) && (
              <TableRow style={{ borderBottom: "1px solid #eeeeee" }}>
                <TableCell style={{ borderBottom: 0 }} colSpan={6}>
                  {t("common.noRecordFound")}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <div className={styles.footer}>
        <PerPage limit={perPage} setLimit={setPerPage} />
        {totalData > perPage && (
          <Pagination
            totalData={totalData}
            limit={perPage}
            offset={pageNumber}
            handlePageClick={offset => {
              handlePaginationChange(offset);
            }}
          />
        )}
      </div>
    </Fragment>
  );
};

export default SortableTable;
